import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  input: {
    fontSize: 36,
    lineHeight: 'normal',
    padding: theme.spacing(15, 4, 3),
    height: 'auto',
    fontWeight: 600,
  },

  withPadding: {
    paddingRight: theme.spacing(16),
  },
}));
